import { Paper } from "@mui/material";

import DefaultDataGrid from "components/MUI/DataGrid/DefaultDataGrid";

import { usePclContext } from "../../context/PclContextProvider";

import { pclColumns } from "./PclColumns";
import { PclToolbar } from "./PclToolbar";

export default function ProductTableView() {
  const { products, isLoading, filters } = usePclContext();

  const status = filters.status;

  const isInProgress = status === "In Progress";
  const isNotArchivedOrInProgress = !isInProgress && status !== "Archived";

  return (
    <Paper
      elevation={1}
      sx={{
        display: "flex",
        flexDirection: "column",
        flex: 1,
        overflow: "hidden",
        margin: 0,
        marginTop: "1em",
        padding: 0,
        height: "100%",
      }}
    >
      <DefaultDataGrid
        loading={isLoading}
        rows={products}
        columns={pclColumns}
        getRowId={(row) => row.product_id}
        pageSizeOptions={[5, 10, 20, 50, 100]}
        columnVisibilityModel={{
          certification_date: isNotArchivedOrInProgress,
          kicked_off_date: isInProgress,
          am_sort: isNotArchivedOrInProgress,
          "project_maintenance_product.headerName": isNotArchivedOrInProgress,
        }}
        initialState={{
          pagination: {
            paginationModel: { pageSize: 50, page: 0 },
          },
        }}
        disableColumnFilter
        disableColumnSelector
        disableDensitySelector
        slots={{ toolbar: PclToolbar }}
        getEstimatedRowHeight={() => 48}
        sx={{
          ".MuiDataGrid-cell": {
            padding: "1em",
            borderTop: "none",
          },
          ".MuiDataGrid-row": {
            alignItems: "center",
            borderTop: "1px solid var(--rowBorderColor)",
          },
          flex: 1,
        }}
        // this is deprecated, BUT
        // if you dont have it theres a non harmful dev only bug that shows up :(
        // "ResizeObserver loop completed with undelivered notifications."
        // If you see this you can safely close the overlay and ignore it
        // MANY hours went into this discovery and I honestly want to cry
        // feel free to take a crack at getting around this if you have hours to spare
        autoHeight={true}
      />
    </Paper>
  );
}
